// extracted by mini-css-extract-plugin
export var base = "_4d-0";
export var updateBanner = "_4d-1";